<script setup lang="ts">
import {
  onMounted, type Ref, ref, inject,
} from 'vue';
import {
  CdrCard, CdrText,
} from '@rei/cedar';
import { sendClickAnalytics } from '../../utils';
import tags from '../../utils/globalTags';
import { useIcons } from '../../common/composables/useIcons';
import { apiCall } from '../../api/services/apiCalls';
import { HelpTopicCard } from '../../api/types/HelpTopicCard';

type centerId = {HelpCenterId: Ref<string>, HelpCenterName: Ref<string>, setHelpCenterValue: (name: string, id?:string) => void};
const mainArray: Ref<HelpTopicCard[]> = ref([]);
const activeCenter = ref('');
const { setHelpCenterValue } = inject<centerId>('centerId');

const helpCardsMetricHandler = async (adobeName?: string) => {
  const clickData = {
    pageName: '',
    linkName: `${tags.HELP_CENTER_HOMEPAGE}_${adobeName.split(' ').join('_')}`,
  };
  sendClickAnalytics(clickData);
};

const resetContent = async () => {
  mainArray.value = await apiCall('default', 'help-topics');
};

const handleClick = ({ helpCenterName, helpCenterId, isBackButton }) => {
  if (isBackButton) {
    resetContent();
    return;
  }
  activeCenter.value = helpCenterName;
  setHelpCenterValue(helpCenterName, helpCenterId);
  helpCardsMetricHandler(helpCenterName);
};

onMounted(async () => {
  if (!mainArray.value.length) {
    resetContent();
  }
});
</script>

<template>
  <div class="help-centers__column help-centers__column-primary">
    <div
      v-for="(helpCenter) in mainArray"
      :key="helpCenter.helpCenterName"
      class="help-centers__cards-wrap"
    >
      <CdrCard
        :class="`help-centers__card
          ${helpCenter.helpCenterName === activeCenter && 'help-centers__card--active'}
          ${helpCenter.isBackButton && 'help-centers__card--back'}`"
        :data-ui="helpCenter.helpCenterName"
        :key="helpCenter.helpCenterName"
        tag="button"
        tabindex="0"
        @click="handleClick(helpCenter)"
      >
        <div class="help-centers__icon-div">
          <component
            :is="useIcons(helpCenter.helpCenterIcon || 'IconReturns')"
            class="help-centers__icon"
          />
        </div>
        <div>
          <CdrText
            tag="h3"
            class="help-center-card-header"
          >
            {{ helpCenter.helpCenterName }}
          </CdrText>
        </div>
      </CdrCard>
    </div>
  </div>
</template>

<style lang="scss">
  @import 'src/main/style/helpCentersColumns.scss';
</style>
